import type { TelemetryConfig } from "../schema/config.js";
import type { TelemetryConfigInput } from "../schema/config.js";
import { parseTelemetryConfig } from "../schema/config.js";

export function mergeTelemetryConfig(
  base: TelemetryConfigInput | undefined,
  override: Partial<TelemetryConfigInput> | undefined,
  runtime?: TelemetryConfigInput["runtime"],
): TelemetryConfig {
  const appId = override?.appId ?? base?.appId;
  if (!appId) {
    throw new Error("[telemetry] DI config requires appId on config or client/server override");
  }

  return parseTelemetryConfig({
    ...base,
    ...override,
    appId,
    runtime: override?.runtime ?? runtime ?? base?.runtime,
    providers: override?.providers ?? base?.providers,
    context: { ...base?.context, ...override?.context },
  });
}
